/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CardAccountTransactionIntent = typeof CardAccountTransactionIntent[keyof typeof CardAccountTransactionIntent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountTransactionIntent = {
  charge: 'charge',
  refund: 'refund',
  topup: 'topup',
  withdraw: 'withdraw',
  transfer: 'transfer',
  repay: 'repay',
  cashback: 'cashback',
  interest: 'interest',
  fee: 'fee',
  other: 'other',
} as const;
